import { render, staticRenderFns } from "./itemCreateEdit.vue?vue&type=template&id=31c25f3e&"
import script from "./itemCreateEdit.vue?vue&type=script&lang=js&"
export * from "./itemCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./itemCreateEdit.vue?vue&type=style&index=0&id=31c25f3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports